import { useModelContext } from '@app/contexts/model';
import { useStorageTranslateContext } from '@app/modules/Translate/contexts/storage';
import { Grid } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';
import { ButtonSetTranslation } from './views/ButtonSetTranslation';
import { SelectedTranslation } from './views/SelectedTranslation';
import { SelectMain } from './views/SelectMain';
import { SelectTarget } from './views/SelectTarget';

export const SelectedTranslate: FunctionComponent = observer(() => {
    const { languageFileModel } = useModelContext();
    const { translateStore } = useStorageTranslateContext();

    let dataLanguageResponse = languageFileModel.dataLanguage.get();

    return (
        <Box sx={{ flexGrow: 1, minHeight: '71px' }}>
            {dataLanguageResponse ? (
                <Stack spacing={1}>
                    <SelectedTranslation />
                </Stack>
            ) : (
                <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={4} sm={3} md={3}>
                        <SelectMain />
                    </Grid>
                    <Grid item xs={4} sm={3} md={3}>
                        <SelectTarget />
                    </Grid>
                    <Grid item xs={2} sm={2} md={3} sx={{ marginTop: 'auto' }}>
                        <ButtonSetTranslation />
                    </Grid>
                </Grid>
            )}
        </Box>
    );
});
